import { createFileRoute, Outlet } from '@tanstack/react-router'

// @ts-ignore - Route type generation issue in Jest
export const Route = createFileRoute('/api-docs')({
  staticData: {
    title: 'API Docs',
    isSecured: true,
  },
  component: ApiDocsLayout,
})

function ApiDocsLayout() {
  return <Outlet />
}
